import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

  // Estilos para el PDF
  const styles = StyleSheet.create({
    textareaLabel: {
      fontSize: 12,
      textAlign: 'justify',
      marginBottom: 8,
      lineHeight: 1.5,
      fontWeight: 'bold', // Para resaltar el texto
      fontFamily: 'Times-Bold',
      marginTop: 10
    },
    checkboxContainerHorizontal: {
      flexDirection: 'row',
      flexWrap: 'wrap', // Permite que las opciones largas se envuelvan
      alignItems: 'center',
      marginTop: 5,
      marginBottom: 5,
      gap: 15, // Espacio entre grupos
    },

    checkbox: {
      width: 12,
      height: 12,
      borderWidth: 1,
      borderColor: '#000',
      marginRight: 5,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fff',
      flexShrink: 0, // Evita que el checkbox se encoja
    },
    checkboxText: {
      fontSize: 8,
      fontFamily: 'Times-Roman',
      flexWrap: 'wrap', // Permite que el texto largo se envuelva
      flexShrink: 1, // Permite que el texto se ajuste,
      color: "#000",
  
    },
    title_respuesta_checkbox: {
      fontSize: 12,
      marginTop: 7,
      textAlign: 'justify', // Justifica el texto
      marginBottom: 5,
    },
  });
const CheckboxGroup = ({ label, selectedValue = {}, options = ["Sí", "No"] }) => {
  // Asegurar que `selectedValues` siempre sea un array
  const selectedValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue];


  return (
    <>
      <Text style={styles.textareaLabel}>- {label}</Text>
      <View style={styles.checkboxContainerHorizontal}>
        {options.map((option) => (
          <View key={option} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <View style={[styles.checkbox, selectedValues.includes(option) ? styles.checked : null]}>
              <Text style={styles.checkboxText}>{selectedValues.includes(option) ? "X" : ""}</Text>
            </View>
            <Text style={styles.title_respuesta_checkbox}>{option}</Text>
          </View>
        ))}
      </View>
    </>
  );
};

export default CheckboxGroup;
